import * as Models from "../../Models";
import * as Services from "../../Services";
import * as _ from 'lodash'

export class InvoiceCtrl {

    public static $inject = [
        "$scope",
        "UserService"
    ];

    constructor($scope: any, private userService: Services.UserService.IUserService) {
        //this is the angular controller
        //look at the react component for logic
        //passing permissions down as props
        this.userService.getCurrentUser().then(user => {
            if (!user) {
                $scope.permissions = { commercial: false, residential: false }
            } else {
                const roleList = new Models.Auth.RoleList.RoleList();

                const roleNames = user.roles.map((x: any) => {
                    return x.name;
                });

                $scope.permissions = {
                    commercial: _.includes(roleNames, roleList.manageCommercialInvoices),
                    residential: _.includes(roleNames, roleList.manageResidentialInvoices)
                };
            }
        });
    }
}
